import { gql } from '@apollo/client'

const GET_FUNDER_BY_ID = gql`
  query FunderOrg($id: Int!) {
    funderOrg(id: $id) {
      id
      name
      disabled
      isTest
      createdAt
      updatedAt
      disabledAt
      nonprofitOrgs {
        id
        name
      }
      cohorts {
        id
        name
      }
      users {
        id
        email
        firstName
        lastName
      }
    }
  }
`

export default GET_FUNDER_BY_ID
